import { DetailedHTMLProps, InputHTMLAttributes, LegacyRef } from 'react';

import styles from '@components/fieldsNative/WorksheetInput.module.css';

type Props = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  innerRef?: LegacyRef<HTMLInputElement>;
};

const WorksheetInput = ({ innerRef, ...inputProps }: Props) => (
  <div>
    <div className={styles.relativeWrapper}>
      <input className={styles.input} {...inputProps} ref={innerRef} type="text" />
    </div>
  </div>
);

export default WorksheetInput;
